import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  Stack,
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { NotificationManager } from "react-notifications";
import { useParams, useNavigate } from "react-router-dom";
import {
  UpdateUser,
  GetVlpUser,
  SaveNewUser,
} from "../../../services/UsersService";
import CommonLoader from "../../common/CommonLoader";

const SectionCard = ({ title, children }) => (
  <Card variant="outlined" sx={{ mb: 3 }}>
    <CardHeader
      title={title}
      titleTypographyProps={{ variant: "subtitle1", fontWeight: 600 }}
      sx={{ pb: 0 }}
    />
    <CardContent>
      <Grid container spacing={2}>
        {children}
      </Grid>
    </CardContent>
  </Card>
);

const EditUser = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    operator: "",
    aliasName: "",
    fullName: "",
    address: "",
    address2: "",
    city: "",
    state: "",
    zip: "",
    phone1: "",
    phone2: "",
    phone3: "",
    contact: "",
    contactphone: "",
    birthdate: "",
    email: "",
    limsAdministrator: false,
    title: "",
    showtips: false,
    groupName: "",
    labAdministrator: false,
    projectManager: false,
    salesPerson: false,
    batchNumber: "",
    machineId: "",
    tbdock: "",
    autosize: false,
    departmentCode: "",
    alldepartments: false,
    comments: "",
    spid: "",
    isReportAdmin: false,
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const loadUser = async () => {
      try {
        console.log("userId : ", userId);
        setLoading(true);
        const res = await GetVlpUser(userId);
        const response = res.results;

        setFormData({
          operator: response.operator || "",
          aliasName: response.aliasName || "",
          fullName: response.fullName || "",
          address: response.address || "",
          address2: response.address2 || "",
          city: response.city || "",
          state: response.state || "",
          zip: response.zip || "",
          phone1: response.phone1 || "",
          phone2: response.phone2 || "",
          phone3: response.phone3 || "",
          contact: response.contact || "",
          contactphone: response.contactphone || "",
          birthdate: response.birthdate
            ? response.birthdate.slice(0, 10)
            : null,
          email: response.email || "",
          limsAdministrator: response.limsAdministrator || false,
          title: response.title || "",
          showtips: response.showtips || false,
          groupName: response.groupName || "",
          labAdministrator: response.labAdministrator || false,
          projectManager: response.projectManager || false,
          salesPerson: response.salesPerson || false,
          batchNumber: response.batchNumber || "",
          machineId: response.machineId || "",
          tbdock: response.tbdock || "",
          autosize: response.autosize || false,
          departmentCode: response.departmentCode || "",
          alldepartments: response.alldepartments || false,
          comments: response.comments || "",
          spid: response.spid || "",
          isReportAdmin: response.isReportAdmin || false,
          password: "",
        });
      } catch (error) {
        NotificationManager.error("Failed to load user data.");
      } finally {
        setLoading(false);
      }
    };
    if (userId !== undefined) {
      loadUser();
    }
  }, [userId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.aliasName) errors.aliasName = "Alias Name is required.";
    if (!formData.fullName) errors.fullName = "Full Name is required.";
    if (!formData.address) errors.address = "Address is required.";
    if (!formData.city) errors.city = "City is required.";
    if (!formData.state) errors.state = "State is required.";
    if (!formData.zip) errors.zip = "Zip Code is required.";
    if (!formData.phone1) errors.phone1 = "Phone 1 is required.";
    if (!formData.email) errors.email = "Email is required.";
    if (userId === undefined && !formData.password) {
      errors.password = "Password is required for new users.";
    }

    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach((error) =>
        NotificationManager.error(error)
      );
      return false;
    }

    return true;
  };

  const handleSaveClick = async () => {
    if (validateForm()) {
      const data = {
        operator: formData.operator || "",
        aliasName: formData.aliasName || "",
        fullName: formData.fullName || "",
        address: formData.address || "",
        address2: formData.address2 || "",
        city: formData.city || "",
        state: formData.state || "",
        zip: formData.zip || "",
        phone1: formData.phone1 || "",
        phone2: formData.phone2 || "",
        phone3: formData.phone3 || "",
        contact: formData.contact || "",
        contactphone: formData.contactphone || "",
        birthdate: formData.birthdate
          ? new Date(formData.birthdate).toISOString()
          : null,
        email: formData.email || "",
        limsAdministrator:
          formData.limsAdministrator === true ||
          formData.limsAdministrator === false
            ? formData.limsAdministrator
            : null,
        title: formData.title || "",
        showtips:
          formData.showtips === true || formData.showtips === false
            ? formData.showtips
            : null,
        groupName: formData.groupName || "",
        loginTime: formData.loginTime
          ? new Date(formData.loginTime).toISOString()
          : null,
        logoutTime: formData.logoutTime
          ? new Date(formData.logoutTime).toISOString()
          : null,
        loginStatus:
          formData.loginStatus === true || formData.loginStatus === false
            ? formData.loginStatus
            : null,
        loginScript: formData.loginScript || "",
        labAdministrator:
          formData.labAdministrator === true ||
          formData.labAdministrator === false
            ? formData.labAdministrator
            : null,
        projectManager:
          formData.projectManager === true || formData.projectManager === false
            ? formData.projectManager
            : null,
        salesPerson:
          formData.salesPerson === true || formData.salesPerson === false
            ? formData.salesPerson
            : null,
        batchNumber: formData.batchNumber
          ? parseInt(formData.batchNumber, 10)
          : null,
        machineId: formData.machineId || "",
        tbdock: formData.tbdock ? parseInt(formData.tbdock, 10) : null,
        autosize:
          formData.autosize === true || formData.autosize === false
            ? formData.autosize
            : null,
        departmentCode: formData.departmentCode || "",
        alldepartments:
          formData.alldepartments === true || formData.alldepartments === false
            ? formData.alldepartments
            : null,
        comments: formData.comments || "",
        spid: formData.spid ? parseInt(formData.spid, 10) : null,
        isReportAdmin: formData.isReportAdmin === true,
        password: formData.password || null,
      };

      if (userId !== undefined) {
        updateUser(data);
      } else {
        saveNewUser(data);
      }
    }
  };

  const saveNewUser = async (data) => {
    try {
      setLoading(true);
      await SaveNewUser(data);
      NotificationManager.success("User saved successfully.");
      navigate("/vlp/settings-users");
    } catch (error) {
      NotificationManager.error("Failed to save user.");
    } finally {
      setLoading(false);
    }
  };

  const updateUser = async (data) => {
    try {
      setLoading(true);
      await UpdateUser(data);
      NotificationManager.success("User updated successfully.");
      navigate("/vlp/settings-users");
    } catch (error) {
      NotificationManager.error("Failed to update user.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancelClick = () => {
    navigate("/vlp/settings-users");
  };

  return (
    <>
      {loading && <CommonLoader loading={loading} />}
      <div className="vlp-component-container">
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Typography variant="h5" fontWeight={600}>
            {userId !== undefined ? "Edit User" : "New User"}
          </Typography>
          <Stack direction="row" spacing={1.5}>
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<AdminPanelSettingsIcon />}
              onClick={() =>
                navigate(`/edit-user-permissions/${formData.operator}`)
              }
              disabled={!userId}
            >
              Edit Permissions
            </Button>
            <Button
              variant="outlined"
              startIcon={<GroupIcon />}
              onClick={() => navigate(`/edit-user-groups/${formData.operator}`)}
              disabled={!userId}
            >
              Manage Access Groups
            </Button>
          </Stack>
        </Box>
        <hr />

        <SectionCard title="Basic Information">
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Operator"
              name="operator"
              value={formData.operator}
              onChange={handleChange}
              InputProps={{
                readOnly: userId !== undefined,
              }}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Alias Name"
              name="aliasName"
              value={formData.aliasName}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Full Name"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Title"
              name="title"
              value={formData.title}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              label="Birthdate"
              name="birthdate"
              type="date"
              value={formData.birthdate}
              onChange={handleChange}
              fullWidth
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </SectionCard>

        <SectionCard title="Security">
          <Grid item xs={12} sm={6} md={4}>
            <TextField
              label={
                userId !== undefined ? "Reset Password" : "Password"
              }
              name="password"
              type="password"
              autoComplete="new-password"
              value={formData.password}
              onChange={handleChange}
              helperText={
                userId !== undefined
                  ? "Leave blank to keep the current password."
                  : "Required for new users."
              }
              fullWidth
              size="small"
            />
          </Grid>
        </SectionCard>

        <SectionCard title="Address Information">
          <Grid item xs={12} md={6}>
            <TextField
              label="Address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Address 2"
              name="address2"
              value={formData.address2}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="City"
              name="city"
              value={formData.city}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="State"
              name="state"
              value={formData.state}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <TextField
              label="Zip"
              name="zip"
              value={formData.zip}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
        </SectionCard>

        <SectionCard title="Contact Information">
          <Grid item xs={12} sm={4}>
            <TextField
              label="Phone 1"
              name="phone1"
              value={formData.phone1}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Phone 2"
              name="phone2"
              value={formData.phone2}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              label="Phone 3"
              name="phone3"
              value={formData.phone3}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Contact"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Contact Phone"
              name="contactphone"
              value={formData.contactphone}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
        </SectionCard>

        <SectionCard title="System Configuration">
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Group Name"
              name="groupName"
              value={formData.groupName}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Department Code"
              name="departmentCode"
              value={formData.departmentCode}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Machine ID"
              name="machineId"
              value={formData.machineId}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="Batch Number"
              name="batchNumber"
              value={formData.batchNumber}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="TB Dock"
              name="tbdock"
              value={formData.tbdock}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label="SPID"
              name="spid"
              value={formData.spid}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField
              label="Comments"
              name="comments"
              value={formData.comments}
              onChange={handleChange}
              fullWidth
              size="small"
              multiline
              rows={2}
            />
          </Grid>
        </SectionCard>

        <SectionCard title="User Permissions">
          <Grid item xs={12} sm={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.limsAdministrator}
                  onChange={handleChange}
                  name="limsAdministrator"
                />
              }
              label="LIMS Administrator"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.labAdministrator}
                  onChange={handleChange}
                  name="labAdministrator"
                />
              }
              label="Lab Administrator"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.projectManager}
                  onChange={handleChange}
                  name="projectManager"
                />
              }
              label="Project Manager"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.salesPerson}
                  onChange={handleChange}
                  name="salesPerson"
                />
              }
              label="Sales Person"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.isReportAdmin}
                  onChange={handleChange}
                  name="isReportAdmin"
                />
              }
              label="Report Admin"
            />
          </Grid>
        </SectionCard>

        <SectionCard title="UI Preferences">
          <Grid item xs={12} sm={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.showtips}
                  onChange={handleChange}
                  name="showtips"
                />
              }
              label="Show Tips"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.autosize}
                  onChange={handleChange}
                  name="autosize"
                />
              }
              label="Auto Size"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.alldepartments}
                  onChange={handleChange}
                  name="alldepartments"
                />
              }
              label="All Departments"
            />
          </Grid>
        </SectionCard>

        <Box
          sx={{ mt: 1, mb: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}
        >
          <Button
            variant="outlined"
            onClick={handleCancelClick}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSaveClick}
            disabled={loading}
          >
            Save
          </Button>
        </Box>
      </div>
    </>
  );
};

export default EditUser;
